import { useRef, useState } from "react"
import { useInView } from "react-intersection-observer"
import { ReactPlayerProps } from "react-player"
import ReactPlayer from "react-player/lazy"

import styled from "styled-components"
import { Desktop, Mobile } from "./MediaQueries"
import NextImage from "./bit/NextImage"
const Styled = {
  PlayerWrapper: styled.div`
    height: 100%;
    width: 100%;
    position: relative;
  `,
  ReactPlayer: styled(ReactPlayer).attrs({
    width: "100%",
    height: "100%",
  })<{
    $cover?: boolean
  }>`
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    video {
      object-fit: ${(p) => (p.$cover ? "cover" : "contain")} !important;
    }
  `,
}
const isUrlIsVideo = (url: string) => {
  const videoExtensions = ["mp4", "webm", "ogg"]
  const urlExtension = url.split(".").pop()
  return videoExtensions.includes(urlExtension)
}

type VideoPlayerProps = ReactPlayerProps & {
  url: string
  isFullHeight?: boolean
  label: string
  playingState: boolean
  imgUrlDesktop?: string
  imgUrlMobile?: string
  imgAlt?: string
  cover?: boolean
}

export default function VideoPlayer({
  url,
  label,
  playingState,
  imgUrlDesktop,
  imgUrlMobile,
  imgAlt,
  cover = true,
  ...props
}: VideoPlayerProps) {
  const player = useRef()
  const [videoLoaded, setVideoLoaded] = useState(false)
  // add useInView to load video only when in view with 300 pixel offset
  const { ref, inView } = useInView({
    threshold: 0,
    triggerOnce: true,
    rootMargin: "800px",
  })

  return (
    <Styled.PlayerWrapper ref={ref}>
      {inView && (
        <Styled.ReactPlayer
          {...props}
          $cover={cover}
          url={inView ? url : ""}
          ref={player}
          controls={false}
          playing={playingState}
          muted={true}
          onReady={() => setVideoLoaded(true)}
          fallback={
            <>
              <Desktop>
                {!videoLoaded && !isUrlIsVideo(imgUrlDesktop) && (
                  <NextImage
                    cover={cover}
                    image={{ imageUrl: imgUrlDesktop, alt: imgAlt }}
                  />
                )}
              </Desktop>
              <Mobile>
                {!videoLoaded && !isUrlIsVideo(imgUrlMobile) && (
                  <NextImage
                    cover={cover}
                    image={{ imageUrl: imgUrlMobile, alt: imgAlt }}
                  />
                )}
              </Mobile>
            </>
          }
          config={{
            file: {
              attributes: {
                "aria-label": `סרטון המתאר את ${label}`,
              },
            },
          }}
          // for iphone!
          playsinline={true}
        />
      )}
      <Desktop>
        {!videoLoaded && !isUrlIsVideo(imgUrlDesktop) && (
          <NextImage
            cover={cover}
            image={{ imageUrl: imgUrlDesktop, alt: imgAlt }}
          />
        )}
      </Desktop>
      <Mobile>
        {!videoLoaded && !isUrlIsVideo(imgUrlMobile) && (
          <NextImage
            cover={cover}
            image={{ imageUrl: imgUrlMobile, alt: imgAlt }}
          />
        )}
      </Mobile>
    </Styled.PlayerWrapper>
  )
}
